var _defs, _rect, _g, _g2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroAbstract(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 900",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "14%",
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#2b1b4f",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72%",
    stopColor: "#5b2b2a",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4a0f2a",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "orbPurple",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c3aed",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2b1b4f",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2b1b4f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "orbWarm",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b45309",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#7f1d1d",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7f1d1d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "orbRed",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ef4444",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#4a0f2a",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4a0f2a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur40",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur18",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lineLight",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#ffffff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#ffffff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lineViolet",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c3aed",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#7c3aed",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ef4444",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1180,
    cy: 250,
    r: 210,
    fill: "url(#orbPurple)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1320,
    cy: 640,
    r: 260,
    fill: "url(#orbRed)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 760,
    r: 240,
    fill: "url(#orbWarm)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#blur18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 560 C 420 420, 620 640, 910 520 C 1110 438, 1285 350, 1500 420",
    stroke: "url(#lineLight)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 300 C 520 210, 740 340, 980 270 C 1170 212, 1330 120, 1515 200",
    stroke: "url(#lineViolet)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 740 C 420 680, 620 820, 900 740 C 1080 690, 1240 590, 1490 650",
    stroke: "url(#lineLight)",
    strokeWidth: 4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 462,
    r: 6,
    fill: "#e11d48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroAbstract);
export default __webpack_public_path__ + "static/media/hero-abstract.01152e6122211c8f520d2b50164dce7d.svg";
export { ForwardRef as ReactComponent };